import * as Sentry from '@sentry/react';

function handleError(error: unknown, context: string) {
  // console.error(`${context}:`, error);
  Sentry.captureException(error, { extra: { context } });
}

export { handleError };
